import { FormItemType } from '@src/framework/workbench/drawer/constants';
import i18n from '@i18next/i18n';
import { ChartFormItemKey } from '@tencent/chart-drawer-components/lib/schema';
import React from 'react';
import type { FormConfig } from '@tencent/wb-ext-form';

export const FORM_CONFIGS: FormConfig[] = [
    {
        type: FormItemType.BUTTON,
        name: ChartFormItemKey.DATA_EDITOR,
        options: {
            icon: <span style={{ fontSize: 12 }}>{i18n.t('编辑数据')}</span>,
        },
    },
];
